import type { ActiveTeam } from './activeTenant';

/**
 * The built-in "current workspace" team. Its bundleKey is '' (empty), so
 * {@link buildMetaInfo} leaves storeBundleInfoIdentifier unset and requests
 * resolve to the backend DEFAULT bundle — i.e. the existing (pre-multi-tenant)
 * data stays visible. Selecting it enters the app directly, no access check.
 */
export const BUILT_IN_TEAM: ActiveTeam = {
  bindleId: '',
  teamName: 'Mercury / RTVE',
  bundleKey: '',
};

/** True when the given active team is the built-in current workspace. */
export function isBuiltInTeam(team: { bundleKey: string }): boolean {
  return team.bundleKey === '';
}
